import { createSlice } from '@reduxjs/toolkit'
import { saveState } from '../../localStorage'

export const sessionId = createSlice({
  name: 'sessionId',
  initialState: {
    value: null
  },
  reducers: {
    assignSessionId: (state, action) => {
      state.value = action.payload
      saveState("sessionId", state);
    }
  }
})

// Action creators are generated for each case reducer function
export const { assignSessionId } = sessionId.actions

export default sessionId.reducer